module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker92-api.relevant-digital.com/"}};